import { render, staticRenderFns } from "./AlarmEmptyLink.vue?vue&type=template&id=f9a97122&scoped=true&"
import script from "./AlarmEmptyLink.vue?vue&type=script&lang=js&"
export * from "./AlarmEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a97122",
  null
  
)

export default component.exports